<template>
  <div>
    <div v-if="!loaded_job_locations" class="row">
      <div class="col-12">
        <order_loader :loadingMessage="'Job Locations'"></order_loader>
      </div>
    </div>
    <div v-else>
      <div v-if="basic_info_order_step_completed">
        <ValidationObserver ref="orderLocationsForm" slim>
          <form role="form" @submit.prevent="order_locations_submit">

            <div class="row mb-4" v-if="live_order_locations.length > 0 && !locations_order_step_completed">
              <div class="col-12 text-right">
                <button class="btn orcaBtn sm_btn" @click.prevent="load_live_order_locations">Load company live order locations</button>
              </div>
            </div>

            <div class="row locations" v-for="s in parseInt(locations.number_of_sites)">
              <div class="col-12">
                <b-card :id="'location_' + s" :class="'active'">

                  <div class="job_title_head" @click.prevent="click_location(s)">
                    <div class="row">
                      <div class="col-sm-9">
                        <h3 class="font-weight-bold text-uppercase mb-0">
                          <i class="fas fa-chevron-down job_title_open"></i>
                          <i class="fas fa-chevron-right job_title_closed"></i>
                          Job (Site) Location {{ s }} : <span class="bp_color">{{ return_short_site_name(s) }}</span></h3>
                      </div>
                      <div v-if="locations.number_of_sites > 1" class="col-sm-3">
                        <button @click.prevent="remove_location(s, locations.site[s].short_site_name)" class="btn orcaBtn danger sm_btn float-right mb-3">Remove Location</button>
                      </div>
                    </div>
                  </div>
                  <div class="job_title_body">
                    <div class="row">
                      <div class="col-12">
                        <hr class="mt-0">
                      </div>



                      <ValidationProvider rules="required" v-slot="{errors, classes}" :name="'Short Site Name ' + s" tag="div" class="col-xl-6 form-group">
                        <label class="form-label" :for="'short_site_name_' + s">Short Site Name</label>
                        <input type="text" v-model="locations.site[s].short_site_name" :id="'short_site_name_' + s" :name="'short_site_name_' + s"
                               class="form-input requiredField" :class="classes" @input="forceCapitalize($event, locations.site[s], 'short_site_name')"
                               @blur="check_distinct_short_site_name(locations.site[s].short_site_name, s)">
                        <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                      </ValidationProvider>

                      <div class="col-12">
                        <hr class="mt-0">
                      </div>

                      <div class="col-12">
                        <div class="row">

                            <label class="col-lg-8 cardLabel font-weight-bold" :for="'use_job_number_' + s">Alternative address name (nickname)?</label>
                            <div class="col-lg-4 form-group" style="font-size: 0.7rem;">
                                <bootstrap-toggle v-model="locations.site[s].use_job_number" :id="'use_job_number_' + s" :name="'use_job_number_' + s" :options="{ on: 'Yes', off: 'No' }"/>
                            </div>

                        </div>
                        <div class="row">
                            <ValidationProvider v-if="locations.site[s].use_job_number" rules="" v-slot="{errors, classes}" :name="'Job Number ' + s" tag="div" class="col-xl-6 form-group">
                              <label class="form-label" :for="'customer_job_number_' + s">Alternative address</label>
                              <input type="text" v-model="locations.site[s].customer_job_number" :id="'customer_job_number_' + s" :name="'customer_job_number_' + s"
                                     class="form-input" :class="classes" @input="forceCapitalize($event, locations.site[s], 'customer_job_number')"
                                     @blur="check_distinct_short_site_name(locations.site[s].customer_job_number, s)">
                              <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                            </ValidationProvider>
                        </div>
                      </div>
                      <div class="col-12">
                        <hr class="mt-0">
                      </div>

                      <!-- Job (Site) Address -->
                      <div class="col-xl-6 form-group">
                        <label class="form-label" :for="'job_address' + s">Job (Site) Address (Google Maps Search)</label>
                        <GmapAutocomplete :id="'job_address_' + s" :name="'job_address_' + s" class="form-input input" placeholder=""
                                          @place_changed="set_job_address($event, s)" @input.native="watch_job_address($event, s)"
                                          @keypress.enter="$event.preventDefault()"></GmapAutocomplete>
                      </div>
                      <div class="col-12">
                        <hr class="mb-4">
                        <div class="row">
                          <!-- job address - building -->
                          <div class="col-xl-4 form-group">
                            <label class="form-label" for="personal_building">Building</label>
                            <input type="text" v-model="locations.site[s].address.address_building" id="personal_building" name="personal_building" class="form-input"
                                   @input="forceCapitalize($event, locations.site[s].address, 'address_building')">
                          </div>
                          <!-- job address - street -->
                          <div class="col-xl-4 form-group">
                            <label class="form-label" for="personal_street">Street</label>
                            <input type="text" v-model="locations.site[s].address.address_street" id="personal_street" name="personal_street" class="form-input"
                                   @input="forceCapitalize($event, locations.site[s].address, 'address_street')">
                          </div>
                          <!-- job address - locality -->
                          <div class="col-xl-4 form-group">
                            <label class="form-label" for="personal_locality">Locality</label>
                            <input type="text" v-model="locations.site[s].address.address_locality" id="personal_locality" name="personal_locality" class="form-input"
                                   @input="forceCapitalize($event, locations.site[s].address, 'address_locality')">
                          </div>
                          <!-- job address - city_town -->
                          <ValidationProvider rules="required" v-slot="{errors, classes}" :name="'City / Town ' + s" tag="div" class="col-xl-4 form-group">
                            <label class="form-label" for="personal_city_town">City / Town</label>
                            <input type="text" v-model="locations.site[s].address.address_city_town" id="personal_city_town" name="personal_city_town"
                                   class="form-input requiredField" :class="classes" @input="forceCapitalize($event, locations.site[s].address, 'address_city_town')">
                            <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                          </ValidationProvider>
                          <!-- job address - county -->
                          <div class="col-xl-4 form-group">
                            <label class="form-label" for="personal_county">County</label>
                            <input type="text" v-model="locations.site[s].address.address_county" id="personal_county" name="personal_county" class="form-input"
                                   @input="forceCapitalize($event, locations.site[s].address, 'address_county')">
                          </div>
                          <!-- job address - postcode -->
                          <div class="col-xl-4 form-group">
                            <label class="form-label" for="personal_postcode">Postcode</label>
                            <input type="text" v-model="locations.site[s].address.address_postcode" id="personal_postcode" name="personal_postcode" class="form-input"
                                   @input="forceCapitalize($event, locations.site[s].address, 'address_postcode')">
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-if="show_site_main_contractor_vat" class="row">
                      <div class="col-12">
                        <hr>
                      </div>
                      <!-- Site Main Contractor -->
                      <ValidationProvider rules="required" v-slot="{errors, classes}" :name="'Site Main Contractor ' + s" tag="div" class="col-xl-8 form-group">
                        <label class="form-label" :for="'site_main_contractor_' + s">Site Main Contractor</label>
                        <input type="text" v-model="locations.site[s].site_main_contractor" :id="'site_main_contractor_' + s" :name="'site_main_contractor_' + s"
                               class="form-input requiredField" :class="classes" @input="forceCapitalize($event, locations.site[s], 'site_main_contractor')">
                        <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                      </ValidationProvider>
                      <!-- Site VAT Treatment -->
                      <ValidationProvider
                          v-if="show_project_managed_fields()"
                          rules="required" v-slot="{errors, classes}" :name="'Site VAT Treatment ' + s" tag="div" class="col-xl-4 form-group">
                        <label class="form-label" :for="'site_vat_treatment_' + s">Site VAT Treatment</label>
                        <multiselect v-model="locations.site[s].site_vat_treatment" :id="'site_vat_treatment_' + s" class="requiredField" :class="classes"
                                     :name="'site_vat_treatment_' + s" placeholder="" label="value" :options="ms_opts.site_vat_treatment"></multiselect>
                        <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                        <div class="form-group mt-2" style="font-size: 0.7rem">
                          <template v-if="locations.site[s].site_vat_treatment && locations.site[s].site_vat_treatment.value !== '0%'">
                            <label for="reverseCharge" >Reverse VAT Charge</label>
                            <div v-if="locations.site[s].site_vat_treatment && locations.site[s].site_vat_treatment.value !== '0%'">
                              <bootstrap-toggle v-model="locations.site[s].reverseCharge" :id="'reverse_charge_' + s" :name="'reverse_charge_' + s" :options="{ on: 'Yes', off: 'No' }"/>
                            </div>
                          </template>
                          <label v-else>
                              Reverse charge not available for VAT 0%
                          </label>
                        </div>
                      </ValidationProvider>
                    </div>

                    <div v-if="show_site_main_contractor_vat" class="row">
                      <div class="col-12">
                        <hr>
                      </div>

                      <div class="col-lg-4 form-group" style="font-size: 0.7rem;">
                          <label for="GeoTech">Geo Tech Enabled?</label>
                          <bootstrap-toggle v-model="locations.site[s].geoTechEnabled" :id="'use_job_number_' + s" :name="'use_job_number_' + s" :options="{ on: 'Yes', off: 'No' }"/>
                      </div>

                      <div class="col-12">
                        <hr>
                        <button type="button" class="btn btn-primary text-white" @click="addRam(s)"><i class="fas fa-plus-circle"></i> Add Declaration</button>
                        <div class="mt-2" v-for="(ram, i) in locations.site[s].rams">
                          <Ram :data="ram" @remove-ram="() => removeRam(i, s)"></Ram>
                        </div>
                      </div>

                    </div>

                  </div>

                </b-card>
              </div>
            </div>

            <div class="row mt-3">
              <div class="col-xl-6 form-group">
                <button v-show="locations.number_of_sites < 26" @click.prevent="add_location" class="btn orcaBtn grey_bg">Add Job (site) Location</button>
              </div>
              <div class="col-xl-6 form-group">
                <button class="btn orcaBtn w-100" type="submit">Save Job Locations</button>
              </div>

              <div class="col-12">
                <hr class="mt-3 mb-0">
              </div>
            </div>
          </form>
        </ValidationObserver>
      </div>
      <div v-else class="row">
        <div class="col-12">
          <h5 class="red_color">You must complete all previous sections first before filling out Job Location information.</h5>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import order_loader from "loaders/order_loader";
import BootstrapToggle from 'vue-bootstrap-toggle';
import Ram from 'resources/components/pages/orders/ram.vue';

export default {
  name: "job_locations",
  components: {
    Multiselect,
    order_loader,
    BootstrapToggle,
    Ram
  },
  data() {
    return {
      basic_info: this.$store.state.orders.order_steps.basic_info.data,
      loaded_job_locations: false,
      live_order_locations: [],
      ms_opts: {
        site_vat_treatment: this.$store.state.crm_options.vat_percentage
      },
      order_type: '',
      locations: {
        number_of_sites: 1,
        site: [
          {},
          {
            short_site_name: '',
            address: {
              address_building: null,
              address_street: null,
              address_locality: null,
              address_city_town: null,
              address_county: null,
              address_postcode: null
            },
            site_main_contractor: "",
            site_build_type: null,
            site_vat_treatment: null,
            geoTechEnabled: false,
            reverseCharge: false,
            rams: []
          }
        ],
      }
    }
  },
  computed: {
    /**
     * Has the basic information order step been completed
     * @returns {boolean}
     */
    basic_info_order_step_completed() {
      return this.$store.state.orders.order_steps.basic_info.partial_order_complete
    },
    /**
     * Has this order step been completed before
     * @returns {boolean}
     */
    locations_order_step_completed() {
      return this.$store.state.orders.order_steps.job_locations.partial_order_complete
    },
    /**
     * Depending on the order type - show site main contractor and vat inputs
     * @returns {boolean}
     */
    show_site_main_contractor_vat() {
      return this.order_type !== null &&
          (this.order_type.value === 'Contract' || this.order_type.value === 'Payroll - Contract')
    }
  },
  beforeMount() {
    // load initial data for order step
    this.load_data().then(() => this.loaded_job_locations = true);
  },
  methods: {
    show_project_managed_fields() {
      return this.basic_info?.payroll_solution?.value === 'Project Managed Labour Solutions';
    },
    /**
     * Show or hide project manager multiselect
     * @returns {boolean}
     */
    show_project_manager() {
      return (this.basic_info.payroll_solution !== undefined && this.basic_info.payroll_solution !== null
          && this.basic_info.payroll_solution.value === 'Project Managed Labour Solutions')
    },
    /**
     * Load data for the order step
     * @returns {Promise<unknown>}
     */
    load_data() {
      return new Promise(resolve => {
        // set order type to the selected from basic information step
        if (this.$store.state.orders.order_steps.basic_info.partial_order_complete) {
          this.order_type = this.$store.state.orders.order_steps.basic_info.data.type;
        }
        // if this step has been completed before - load information from vuex store
        if (this.$store.state.orders.order_steps.job_locations.partial_order_complete) {
          this.locations = this.$store.state.orders.order_steps.job_locations.data;
        }

        // get locations from any 'live' orders for the company the order is being raised for
        axios.get(this.crmApiPath + 'order/location/' + this.$store.state.orders.order_steps.basic_info.data.company.id)
             .then(locations => {
               this.live_order_locations = locations.data;
              resolve();
             })
      });
    },
    /**
     * Load companies 'live' order locations into the cco
     */
    load_live_order_locations() {
      this.$snotify.confirm('', '', {
        closeOnClick: false,
        position: 'centerCenter',
        backdrop: 0.5,
        html: '<div class="snotifyToast__title">Confirm location load</div>' +
            '<div class="snotifyToast__body">' +
            'Confirm whether you wish to copy in all live locations for the company to this order.' +
            '<div class="snotify-icon snotify-icon--confirm"><i class="fas fa-2x fa-exclamation-triangle"></i></div>' +
            '</div>',
        buttons: [
          {
            text: 'Confirm load', action: (toast) => {
              // check if not empty (i.e. no live order locations for the company found)
              if (this.live_order_locations.length > 0) {
                // reset step locations sites and number of sites ready to push locations from 'live' orders into
                this.locations.site = [{}]
                this.locations.number_of_sites = 0
                // load locations into the order
                for (let i = 0; i < this.live_order_locations.length; i++) {
                  let location = this.live_order_locations[i],
                      short_site_name = location.short_site_name
                  // check if short site location already exists
                  // if so then add index value of loop to the end of the string
                  if (this.locations.site.find(site => site.short_site_name === location.short_site_name) !== undefined) {
                    short_site_name = short_site_name + ' ' + i
                  }

                  // push location data into the step site array
                  this.locations.site.push({
                    address: {
                      address_building: location.job_address_building,
                      address_street: location.job_address_street,
                      address_locality: location.job_address_locality,
                      address_city_town: location.job_address_city_town,
                      address_county: location.job_address_county,
                      address_postcode: location.job_address_postcode
                    },
                    full_address: null,
                    short_site_name: short_site_name,
                    site_build_type: null,
                    site_main_contractor: location.site_main_contractor,
                    site_vat_treatment: this.$store.state.crm_options.vat_percentage.find(vp => vp.value === location.site_vat_treatment + '%')
                  })
                  // increment the number of sites for the order
                  this.locations.number_of_sites++;
                }
              }
              this.$snotify.remove(toast.id);
            }
          },
          {text: 'Cancel', action: (toast) => this.$snotify.remove(toast.id)}
        ]
      });
    },
    /*
     * ******************************************
     * location head
     * ******************************************
     */
    /**
     * Click on job title to expand and collapse specific location card
     * @param site
     */
    click_location(site) {
      for (let i = 1; i <= this.locations.number_of_sites; i++) {
        let element = document.getElementById("location_" + i);
        let check_active = element.classList.contains("active");
        if (!check_active && i === site) {
          element.classList.add("active");
        }
        else {
          element.classList.remove("active");
        }
      }
    },
    /**
     * Return the short site name for a location
     * @param site_index
     * @returns {string}
     */
    return_short_site_name(site_index) {
      return this.locations.site[site_index].short_site_name
    },
    /**
     * Remove a location from the order
     * @param site
     * @param site_short_name
     */
    remove_location(site, site_short_name) {
      this.$snotify.confirm('', '', {
        closeOnClick: false,
        position: 'centerCenter',
        backdrop: 0.5,
        html: '<div class="snotifyToast__title">Remove Location</div>' +
            '<div class="snotifyToast__body">' +
            '<strong>Are you sure that you want to remove:</strong><br><br>' +
            'Job (Site) Location ' + site + '<br>' +
            site_short_name +
            '<div class="snotify-icon snotify-icon--confirm"><i class="fas fa-2x fa-exclamation-triangle"></i></div>' +
            '</div>',
        buttons: [
          {
            text: 'OK', action: (toast) => {
              this.$snotify.remove(toast.id);
              // splice location from array
              this.locations.site.splice(site, 1);
              // reduce the count of the number of sites
              this.locations.number_of_sites = this.locations.number_of_sites - 1;
            }
          },
          {
            text: 'CANCEL', action: (toast) => this.$snotify.remove(toast.id)
          }
        ]
      });
    },
    /*
     * ******************************************
     * location body
     * ******************************************
     */
    /**
     * Check that the short site name entered is unique to the order
     * @param site_short_name
     * @param site
     */
    check_distinct_short_site_name(site_short_name, site) {
      // loop through all locations
      for (let i = 1; i < this.locations.site.length; i++) {
        // if there is more than one location entered
        if (this.locations.site.length - 1 > 1) {
          // compare to other site short names (not the one just entered)
          if (site !== i) {
            // if there is a location with an identical short site name
            if (this.locations.site[i].short_site_name === site_short_name) {
              this.$snotify.confirm('', '', {
                closeOnClick: false,
                position: 'centerCenter',
                backdrop: 0.5,
                html: '<div class="snotifyToast__title">Short Site Name Taken</div>' +
                    '<div class="snotifyToast__body">' +
                    site_short_name + '<br><br>Has already been used as a short site name please enter another unique name.' +
                    '<div class="snotify-icon snotify-icon--confirm"><i class="fas fa-2x fa-exclamation-triangle"></i></div>' +
                    '</div>',
                buttons: [
                  {
                    text: 'Ok', action: (toast) => {
                      this.$snotify.remove(toast.id);
                      // clear the short site name as it is not unique
                      this.locations.site[site].short_site_name = '';
                    }
                  }
                ]
              });
            }
          }
        }
      }
    },
    /**
     * Google place search - set location address parts
     * @param place
     * @param site
     */
    set_job_address(place, site) {
      let address = this.set_google_address(place)
      // set all address variables
      this.locations.site[site].address.address_building = address.building;
      this.locations.site[site].address.address_street = address.street;
      this.locations.site[site].address.address_locality = address.locality;
      this.locations.site[site].address.address_city_town = address.city_town;
      this.locations.site[site].address.address_county = address.county;
      this.locations.site[site].address.address_postcode = address.postcode;
    },
    /**
     * On text input into Google place search
     * @param event
     * @param site
     */
    watch_job_address(event, site) {
        if (typeof event.path !== 'undefined') {

            // if the Google place input is empty clear address parts
            if (event.path[0].value === '') {
                this.locations.site[site].address.full_address = null;
                this.locations.site[site].address.address_building = null;
                this.locations.site[site].address.address_street = null;
                this.locations.site[site].address.address_locality = null;
                this.locations.site[site].address.address_city_town = null;
                this.locations.site[site].address.address_county = null;
                this.locations.site[site].address.address_postcode = null;
            }
        }
    },
    /*
     * ******************************************
     * Order step level functions
     * ******************************************
     */
    /**
     * If entered site(s) are completed/valid
     * add another location to the order
     */
    add_location() {
      this.$refs.orderLocationsForm.validate().then(success => {
        if (!success) {
          // expand all non-valid locations so content of card is visible
          for (let i = 1; i <= this.locations.number_of_sites; i++) {
            let element = document.getElementById("location_" + i);
            element.classList.add("active");
          }
          // scroll to first non-valid form input
          this.formErrorsValidationScroll(this.$refs.orderLocationsForm);
        }
        else {
          // add an object to the sites array for a new location
          this.locations.site.push({
            short_site_name: '',
            full_address: null,
            address: {
              address_building: null,
              address_street: null,
              address_locality: null,
              address_city_town: null,
              address_county: null,
              address_postcode: null
            },
            site_main_contractor: "",
            site_build_type: null,
            rams: []
          });
          this.$nextTick(() => {
            // increment the number of sites for the order
            this.locations.number_of_sites++;

            this.$nextTick(() => {
              for (let i = 1; i <= this.locations.number_of_sites; i++) {
                let element = document.getElementById("location_" + i);
                // expand the added location card
                if (i === this.locations.number_of_sites) {
                  element.classList.add("active");
                }
                // collapse other locations
                else {
                  element.classList.remove("active");
                }
              }
            });
          });
        }
      });
    },
    /*
     * ******************************************
     * submit order step
     * ******************************************
     */
    order_locations_submit() {
      this.$refs.orderLocationsForm.validate().then(success => {
        if (!success) {
          // expand all locations that have non-valid entries
          for (let i = 1; i <= this.locations.number_of_sites; i++) {
            let element = document.getElementById("location_" + i);
            element.classList.add("active");
          }
          // scroll to first non-valid entry
          this.formErrorsValidationScroll(this.$refs.orderLocationsForm);
          // store values to vuex if there were errors
          this.$store.commit('SAVE_JOB_LOCATIONS_ERRORS', this.locations);
        }
        else {
          // store values to vuex on successful submit
          this.$store.commit('SAVE_JOB_LOCATIONS_COMPLETED', this.locations);
        }
      });
    },
    addRam(siteId) {
      const ram = {
              order_job_id: 0,
              title: null,
              description: null,
              company_required: true,
              worker_required: true,
              link: null,
              file: null
            };

      this.locations.site[siteId].rams.push(ram);
    },
    removeRam(index, siteId) {
      this.locations.site[siteId].rams.splice(index, 1);
    }
  }
}
</script>

<style scoped lang="scss">
.locations {
  margin-top: 15px;

  &:first-of-type {
    margin-top: 0;
  }

  .card {
    height:   60px;
    overflow: hidden;

    .card-body {
      padding: 0;

      .job_title_head {
        padding:       15px 15px 20px 15px;
        border-radius: $border_radius;

        &:hover {
          background: darken($card_background, 10%);
          cursor:     pointer;
        }
      }

      .job_title_body {
        padding: 0 15px 3.5px 15px;
      }
    }

    .job_title_closed, .job_title_open {
      margin-right: 10px;
    }

    .job_title_closed {
      display: inline-block;
    }

    .job_title_open {
      display: none;
    }

    &.active {
      height:   auto;
      overflow: visible;

      .job_title_closed {
        display: none;
      }

      .job_title_open {
        display: inline-block;
      }
    }
  }
}
</style>
